module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a4-7-8ddbd1b552de3cb99d77e0e16ab83d9e.jpg";